module.exports = __webpack_public_path__ + "img/banner2.47b92afc.png";